import React, { useState } from 'react';
import {
  Button,
  Col,
  Container,
  Dropdown,
  Image,
  Modal,
  Row
} from 'react-bootstrap';
import {
  useNavigate
} from "react-router-dom";
import QRCode from "react-qr-code";

import { 
  HiDotsCircleHorizontal,
  HiOutlineChevronLeft,
  HiPlusCircle
} from "react-icons/hi";


import { 
  IoArrowUndoCircle,
  IoQrCodeSharp
} from "react-icons/io5";

import InvoiceForm from '../../components/InvoiceForm';

export default function InvoiceCreate(data) {
  const navigate = useNavigate();

  return (
    <>
      <Container className="content-body g-0 text-start">
        <InvoiceForm />
      </Container>
      <Container className="mt-auto footer-toolbar fixed-bottom">
        <Row>
          <Col>
            <Button onClick={() => navigate("/merchant/dashboard")} variant="link" className="text-decoration-none">
              <IoArrowUndoCircle className="toolbar-icon" />Cancel
            </Button>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </>
  )
}